import { urlRegex } from "../urlRegex";

export const IsUrl = (value: string) => {
  return new RegExp(urlRegex).test(value);
};

export const IsNameValid = (value: string) => {
  if (value) {
    return !IsUrl(value);
  }
  return false;
};
